const rtiPdfContext = require.context(
  "../../../assets/rti_pdf",
  false,
  /\.pdf$/,
);

const rajyaSabhaPdfContext = require.context(
  "../../../assets/rti_pdf/rajya_sabha_pdf",
  false,
  /\.pdf$/,
);

const lokSabhaPdfContext = require.context(
  "../../../assets/rti_pdf/lok_sabha_pdf",
  false,
  /\.pdf$/,
);

const getChapterNumber = (fileName) => {
  const patterns = [
    /chapter[-_\s]*(\d+)/i,
    /chatper[-_\s]*(\d+)/i,
    /cahpter[-_\s]*(\d+)/i,
    /chap[-_\s]*(\d+)/i,
  ];

  for (const pattern of patterns) {
    const match = fileName.match(pattern);
    if (match) {
      return Number(match[1]);
    }
  }

  return null;
};

const getPdfFiles = (pdfContext) =>
  pdfContext.keys().map((key) => ({
    fileName: key.replace("./", ""),
    href: pdfContext(key),
  }));

const getDocumentPdf = (pdfFiles, matchers) => {
  const matchedPdfs = pdfFiles
    .filter(({ fileName }) =>
      matchers.some((matcher) => matcher.test(fileName)),
    )
    .sort((firstPdf, secondPdf) => {
      const firstIsDuplicate = firstPdf.fileName.includes("(1)");
      const secondIsDuplicate = secondPdf.fileName.includes("(1)");
      return Number(firstIsDuplicate) - Number(secondIsDuplicate);
    });

  return matchedPdfs[0] || { fileName: "", href: "" };
};

const pdfsByChapter = rtiPdfContext.keys().reduce((chapterMap, key) => {
  const fileName = key.replace("./", "");
  const chapter = getChapterNumber(fileName);

  if (chapter) {
    chapterMap.set(chapter, {
      fileName,
      href: rtiPdfContext(key),
    });
  }

  return chapterMap;
}, new Map());

const rtiChapterTitles = [
  {
    chapter: 1,
    title:
      "Chapter-1: Introduction, How to apply under RTI act, Quarterly Return Reports and Fee Structure",
  },
  {
    chapter: 2,
    title:
      "Chapter 2: Organisation structure, functions and duties [SECTION 4(1)(B)(i)]",
    path: "/right-to-information/chapter-2",
  },
  {
    chapter: 3,
    title:
      "Chapter-3: Powers and duties of Officers and employees [SECTION 4(1)(B)(ii)]",
  },
  {
    chapter: 4,
    title:
      "Chapter 4: Rules, Regulations, Instruction Manuals and records for discharging functions [SECTION 4(1)(B)(v)]",
    path: "/right-to-information/chapter-4",
  },
  {
    chapter: 5,
    title:
      "Chapter-5: Powers and duties of Officers and employees [SECTION 4(1)(B)(ii)]",
  },
  {
    chapter: 6,
    title:
      "Chapter 6: Categories of documents held by the authority under its control [SECTION 4(1)(B)(vi)]",
  },
  {
    chapter: 7,
    title:
      "Chapter-7: A statement of Boards, Council, Committees and other bodies [SECTION 4(1)(B)(viii)]",
  },
  {
    chapter: 8,
    title:
      "Chapter 8: Name, designations and other particulars of the PIOs [SECTION 4(1)(B)(xvi)]",
  },
  {
    chapter: 9,
    title:
      "Chapter-9: Procedure followed in decision making process, [SECTION 4(1)(B)(iii)]",
  },
  {
    chapter: 10,
    title:
      "Chapter 10: Directory of officers and employees [SECTION 4(1)(B)(ix)]",
    path: "/right-to-information/chapter-10",
  },
  {
    chapter: 11,
    title:
      "Chapter-11: Monthly remuneration received by officers and employees, [SECTION 4(1)(B)(x)]",
  },
  {
    chapter: 12,
    title:
      "Chapter 12: Budget allocated, plans, proposed expenditures and reports on disbursement made [SECTION 4(1)(B)(xi)]",
    path: "/right-to-information/chapter-12",
  },
  {
    chapter: 13,
    title:
      "Chapter-13: Manner of execution of subsidy programmes [SECTION 4(1)(B)(xii)]",
    path: "/right-to-information/chapter-13",
  },
  {
    chapter: 14,
    title:
      "Chapter 14: Particulars of recipients of concessions, permits [SECTION 4(1)(B)(xiii)]",
  },
  {
    chapter: 15,
    title:
      "Chapter-15: Norms set for the discharge of functions [SECTION 4(1)(B)(iv)]",
  },
  {
    chapter: 16,
    title:
      "Chapter 16: Information available to or held by, reduced in an electric form [SECTION 4(1)(B)(xiv)]",
  },
  {
    chapter: 17,
    title:
      "Chapter-17: Facilities available to citizens for obtaining information [SECTION 4(1)(B)(xv)]",
  },
  {
    chapter: 18,
    title: "Chapter 18: Other information",
    path: "/right-to-information/chapter-18",
  },
];

export const rtiActDocuments = rtiChapterTitles.map((document, index) => {
  const pdf = pdfsByChapter.get(document.chapter);

  return {
    ...document,
    serial: index + 1,
    fileName: pdf?.fileName || "",
    href: pdf?.href || "",
  };
});

const rajyaSabhaPdfFiles = getPdfFiles(rajyaSabhaPdfContext);
const lokSabhaPdfFiles = getPdfFiles(lokSabhaPdfContext);

const rajyaSabhaDocumentTitles = [
  {
    title: "R - 2024-25",
    matchers: [/2024[_-]2025/i, /2024[-_]25/i],
  },
  {
    title: "R - 2023-24",
    matchers: [/2023[_-]2024/i, /2023[-_]24/i],
  },
  {
    title: "R - 2022-23",
    matchers: [/2022[-_]23/i],
  },
  {
    title: "R - 2021-22",
    matchers: [/2021[_-]2022/i, /2021[-_]22/i],
  },
  {
    title: "R - 2020-21",
    matchers: [/2020[-_]21/i],
  },
  {
    title: "R - 2019-20 up to March 20",
    matchers: [/2019[-_]20[-_]up[-_]to[-_](Macrh|March)[-_]20/i],
  },
  {
    title: "R - 2019-20 up to July",
    matchers: [/2019[-_]20[-_]up[-_]to[-_]July/i],
  },
  {
    title: "R - 2018-19",
    matchers: [/2018[-_]19/i],
  },
  {
    title: "R - 2017-18",
    matchers: [/2017[-_]18/i],
  },
  {
    title: "R - 2016-17",
    matchers: [/2016[-_]17/i],
  },
  {
    title: "R - 2015-16",
    matchers: [/2015[-_]16/i],
  },
  {
    title: "2014-15",
    matchers: [/2014[-_]15/i],
  },
  {
    title: "2013-14",
    matchers: [/2013[-_]14/i],
  },
  {
    title: "2012-13",
    matchers: [/2012[-_]13/i],
  },
  {
    title: "2010-11",
    matchers: [/2010[-_]11/i],
  },
  {
    title: "2011-2012",
    matchers: [/2011[-_]2012/i],
  },
  {
    title: "2010-2011",
    matchers: [/2010[-_]2011/i],
  },
  {
    title: "2009-10",
    matchers: [/2009[-_]10/i],
  },
];

const lokSabhaDocumentTitles = [
  {
    title: "L - 2026-27",
    matchers: [/^L - 2024-25\.pdf$/i],
  },
  {
    title: "L - 2023-24",
    matchers: [/2023[_-]2024/i, /2023[-_]24/i],
  },
  {
    title: "L - 2022-23",
    matchers: [/2022[-_]23/i],
  },
  {
    title: "L - 2020-21",
    matchers: [/^Parliament Question 2020[-_]21\.pdf$/i],
  },
  {
    title: "L - 2019-20",
    matchers: [/^Parliament Question 2019[-_]20\.pdf$/i],
  },
  {
    title: "L - 2018-19",
    matchers: [/2018[_-]2019/i, /2018[-_]19/i],
  },
  {
    title: "L - 2017-18",
    matchers: [/2017[-_]18/i],
  },
  {
    title: "L - 2016-17",
    matchers: [/2016[-_]17/i],
  },
  {
    title: "L - 2015-16",
    matchers: [/2015[-_]16/i],
  },
  {
    title: "2014-15",
    matchers: [/2014[_-]2015/i, /2014[-_]15/i],
  },
  {
    title: "2013-14",
    matchers: [/2013[_-]2014/i, /2013[-_]14/i],
  },
  {
    title: "2012-13",
    matchers: [/2012[_-]2013/i, /2012[-_]13/i],
  },
  {
    title: "2011-2012",
    matchers: [/2011[-_]2012/i],
  },
  {
    title: "2010-2011",
    matchers: [/2010[-_]2011/i],
  },
  {
    title: "2009-10",
    matchers: [/2009[_-]2010/i, /2009[-_]10/i],
  },
];

export const rajyaSabhaDocuments = rajyaSabhaDocumentTitles.map(
  (document, index) => {
    const pdf = getDocumentPdf(rajyaSabhaPdfFiles, document.matchers);

    return {
      title: `Rajya Sabha Documents - ${document.title.replace(/^R\s*-\s*/, "")}`,
      serial: index + 1,
      fileName: pdf.fileName,
      href: pdf.href,
    };
  },
);

export const lokSabhaDocuments = lokSabhaDocumentTitles.map(
  (document, index) => {
    const pdf = getDocumentPdf(lokSabhaPdfFiles, document.matchers);

    return {
      title: `Lok Sabha Documents - ${document.title.replace(/^L\s*-\s*/, "")}`,
      serial: index + 1,
      fileName: pdf.fileName,
      href: pdf.href,
    };
  },
);
